module.exports = __webpack_public_path__ + "img/1283651682.ee60645d.jpg";